import { Box, Typography, useTheme } from "@mui/material";
import React from "react";
import { Link } from "react-router-dom";
import ArrowLeftSVG from "../../../../../../media/images/icons/arrow-left";
import handUp3d from "../../../../../../media/images/icons/handUp3d.png";
import { theme } from "../../../../../../themes";
import Money_Report from "../../../../../../media/images/icons/Money_Report.png";
import ContactIcon from "../../../../../../media/images/icons/contact.png";
import WalletCoins from "../../../../../../media/images/icons/wallet-coins.png";

export default function SideContent() {
  const theme = useTheme();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Box
        sx={{
          display: "flex",
          backgroundImage: `url(${Money_Report})`,
          backgroundRepeat: "no-repeat",
          backgroundPosition: "top",
          backgroundSize: "50px",
          paddingTop: "50px",
          borderRadius: "16px",
          flexDirection: "column",
          backgroundColor: "primary.main",
          alignItems: "center",
          paddingX: "4px",
        }}
      >
        <Link
          to={"#"}
          style={{
            display: "flex",
            alignItems: "center",
          }}
        >
          <Typography
            sx={{
              color: "#fff",
              fontWeight: "600",
            }}
          >
            مناقصات بار
          </Typography>
          <ArrowLeftSVG />
        </Link>
        <Typography
          sx={{
            fontSize: "10px",
            color: "#fff",
            textAlign: "center",
          }}
        >
          درخواست‌های افزایش قیمت و مناقصات بار
        </Typography>
      </Box>
      <Link
        to={"/driver/profile"}
        style={{
          backgroundImage: `url(${ContactIcon})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "50px",
          backgroundPosition: "110% 50%",
          borderRadius: "8px",
          padding: "12px 4px",
          width: "100%",
          backgroundColor: theme.palette.primary.main,
        }}
      >
        <Typography
          sx={{
            textAlign: "left",
            whiteSpace: "nowrap",
            color: "#fff",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          مشخصات کاربری{" "}
        </Typography>
      </Link>
      <Link
        to={"/driver/wallet"}
        style={{
          backgroundImage: `url(${WalletCoins})`,
          backgroundRepeat: "no-repeat",
          backgroundSize: "50px",
          backgroundPosition: "100% 20%",
          borderRadius: "8px",
          padding: "12px 4px",
          width: "100%",
          backgroundColor: theme.palette.primary.main,
        }}
      >
        <Typography
          sx={{
            textAlign: "left",
            whiteSpace: "nowrap",
            color: "#fff",
            fontSize: "12px",
            fontWeight: "600",
          }}
        >
          کیف پول{" "}
        </Typography>
      </Link>
    </Box>
  );
}
